/**
 * Libellé d'une reprise qui rejoue un inédit (ou un direct) créé dans la même
 * prévisualisation. La reprise peut tomber plusieurs jours après sa tête : dire
 * « le même jour » sur la reprise du jeudi d'un inédit du mercredi était faux.
 * On nomme donc toujours le jour et l'heure de la tête, sauf quand elle passe
 * le jour même, où l'heure suffit.
 */
export function replayOriginLabel(
  replay: { startTime: string },
  origin: { startTime: string; itemType: string } | undefined,
): string {
  const what = origin?.itemType === 'LIVE' ? 'du direct' : 'de l’inédit'
  if (!origin) return `Reprise ${what} réservé dans cette génération`
  const originAt = new Date(origin.startTime)
  const replayAt = new Date(replay.startTime)
  const time = originAt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
  if (originAt.toDateString() === replayAt.toDateString()) return `Reprise ${what} de ${time}, le même jour`
  const day = originAt.toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit' })
  return `Reprise ${what} du ${day} à ${time}`
}
